import { render, staticRenderFns } from "./PristaPack.vue?vue&type=template&id=17d36e5b&scoped=true&"
import script from "./PristaPack.vue?vue&type=script&lang=js&"
export * from "./PristaPack.vue?vue&type=script&lang=js&"
import style0 from "./PristaPack.vue?vue&type=style&index=0&id=17d36e5b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17d36e5b",
  null
  
)

export default component.exports